import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classes from './Search.module.scss';
import { ThemeContext } from '../App/ThemeContext';
import { ReactComponent as Loupe } from '../../assets/imgs/svg/loupe.svg';
import { ReactComponent as Close } from '../../assets/imgs/svg/close-search.svg';

const Search = (props) => {
  const { t } = useTranslation();
  const { theme } = useContext(ThemeContext);
  const { filter, onSearchInput } = props;

  return (
    <div role="search" className={`${classes.Search} ${theme ? classes[theme] : ''}`}>
      <div className={classes.Box}>
        <input
          type="text"
          className={classes.Input}
          placeholder={t('nav.search')}
          onChange={(event) => { onSearchInput(event.target.value); }}
          value={filter}
        />
        <Loupe className={`${classes.Loupe} ${!filter ? '' : classes.hidden}`} />
        <Close
          className={`${classes.Close} ${filter ? '' : classes.hidden}`}
          onClick={() => onSearchInput('')}
        />
      </div>
    </div>
  );
};

export default React.memo(Search);

Search.propTypes = {
  filter: PropTypes.string,
  onSearchInput: PropTypes.func.isRequired,
};

Search.defaultProps = {
  filter: '',
};
